import { render } from "./CASITotalScoreCheckboxInput.vue?vue&type=template&id=cf36ae88&scoped=true"
import script from "./CASITotalScoreCheckboxInput.vue?vue&type=script&lang=js"
export * from "./CASITotalScoreCheckboxInput.vue?vue&type=script&lang=js"

import "./CASITotalScoreCheckboxInput.vue?vue&type=style&index=0&id=cf36ae88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf36ae88"]])

export default __exports__